<template>
  <div class="discover-items-wrapper">
    <div v-if="data.length === 0" class="no-data">
      {{ $t('discover.no_rmd_items') }}
    </div>
    <div v-else class="discover-items-card-wrapper">
      <div class="item-card" v-for="(item, idx) in data" :key="idx" @click="showItem(item)">
        <div class="image-wrap">
          <img class="item-image" :src="item.icon" :alt="item.name" />
        </div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    showItem(item) {
      this.$emit('show-item', item);
    },
  },
};
</script>

<style lang="scss" scoped>

.discover-items-wrapper{
  height: 100%;
}


.discover-items-card-wrapper {
  margin: 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  padding-bottom: 7.5rem;
}


.item-card {
  background-color: #5959591a;
  border-radius: 8px;
  padding: 1rem;
  position: relative;
}

.logo {
  position: absolute;
  z-index: 1;
}

.no-data {
  text-align: center;
  color: #595959;
  margin: 2rem auto;
  justify-content: center;
  display: flex;
  align-items: center;
  line-height: 1;
  font-size: 12px;
  height: 65%;
}

.image-wrap {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 0.5rem;
  position: relative;

  &:before {
    padding-bottom: 100%;
    content: '';
    display: block;
  }

  .item-image {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
    top: 0;
  }
}

.name {
  font-weight: semi-bold;
  font-size: 1rem;
}
</style>
